<template>
  <div v-if="options && data" class="chart-header">
    <img class="img-container" :src="$dashboardOff" alt="" />
    <div class="header-wrapper">
      <p>Energy and Water Production</p>
      <div class="dropdown">
        <button @click="toggleDropdown" class="dropbtn">
          <img :src="$menuIcon" />
        </button>
        <div id="completed-project-dropdown" class="dropdown-content">
          <a @click="openFullscreen">View in Full Screen</a>
          <a @click="printChart">Print Chart</a>
          <hr style="margin: 0" />
          <a v-for="ext in fileExtensions" :key="ext" @click="saveChartAs(ext)"
            >Download as {{ ext }}</a
          >
        </div>
      </div>
    </div>
  </div>

  <div
    id="chart-analytics-completed-wrapper"
    class="chart-analytics-completed-wrapper"
    style="width: 100%; height: 40vh"
  >
    <Chart
      type="chart"
      :options="options"
      :data="data"
      id="analytics-chart-completed"
      height="100%"
      width="100%"
      ref="chart"
    ></Chart>
  </div>
</template>
<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  Filler,
} from 'chart.js'
import { Chart, Bar, Scatter, Line } from 'vue-chartjs'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

export default {
  props: {
    options: Object,
    data: Object,
  },
  data() {
    return {
      fileExtensions: ['PNG', 'JPEG'],
    }
  },
  components: {
    Chart,
    Bar,
    Scatter,
    Line,
  },
  methods: {
    printChart() {
      printCurrChart('analytics-chart-completed')
    },
    async saveChartAs(ext) {
      saveChartToFile(ext, 'analytics-chart-completed')
    },
    openFullscreen() {
      openChartFullScreen('chart-analytics-completed-wrapper')
    },
    toggleDropdown() {
      document
        .getElementById('completed-project-dropdown')
        .classList.toggle('show')
    },
    myEventHandler() {
      this.$refs.chart.chart.resize()
    },
  },
  created() {
    window.addEventListener('resize', this.myEventHandler)
  },
  destroyed() {
    window.removeEventListener('resize', this.myEventHandler)
  },
}
</script>
